import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getExtraTopicThunk = createAsyncThunk(
  "extratopic/get",
  async (params) => {
    const { usertype } = params;
    let response = await api.get("getAllTchExtraModulesTopics/" + usertype + "/" + "od");
    return response.data;
  }
);

export const createExtraTopicThunk = createAsyncThunk(
  "extratopic/create",
  async (body) => {
    let response = await api.post("createNewTchExtraModulesTopic", body);
    return response.data;
  }
);

export const updateExtraTopicThunk = createAsyncThunk(
  "extratopic/update",
  async (reqbody) => {
    const id = reqbody.topicId;
    const { topicId, ...body } = reqbody; // remove _id from reqbody and create new object called body

    let response = await api.put("updateTchExtraModulesTopic/" + topicId, body);
    return response.data;
  }
);

export const deleteExtraTopicThunk = createAsyncThunk(
  "extratopic/delete",
  async (topicId) => {
    let response = await api.delete("deleteTchExtraModulesTopic/" + topicId.topicId);
    return response.data;
  }
);
